import { render } from "./HomeC.vue?vue&type=template&id=64635fa7"
import script from "./HomeC.vue?vue&type=script&lang=js"
export * from "./HomeC.vue?vue&type=script&lang=js"

import "./HomeC.vue?vue&type=style&index=0&id=64635fa7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__